<template>
    <Breadcrumb page-title="Batch Utilities Form" page-section="Pages"> </Breadcrumb>
     <section class="content">
        <div class="box box-info">
           <div class="box-header with-border">
                <i class="fa  fa-list"></i>
                <h3 class="box-title head-title-padding">Submit CSV to Form</h3>
            </div>
            <div class="box-body">
                <div class="row">
                  <div class="col-md-12">
                    <p>Use this page to submit data in bulk by uploading a csv file and processing it against an iService Form or Workflow Submit Panel. Each row in the CSV fil represents a single form submission.</p>
                  </div>
                  
                  <div class="col-md-12">
                      <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Select Your Import Form</h3></div>
                      <div class="col-md-12 mbottom-15">
                       <button class="btn btn-primary mright-15"><strong>iService Standard Form</strong><br><span>Form in tenant setting form</span></button>
                       <button class="btn btn-success"><strong>Workflow Submit Form</strong><br><span>Submit form in workflow</span></button>
                      </div>
                  </div>  
                  <div class="col-md-7">

                      <div class="form-group">
                         <label class="col-sm-12 control-label text-left">Choose the target form from the dropdown. The available forms depend on the form type selected.</label>
                         <div class="col-sm-12">
                            <select class="form-control"><option>--Select Form --</option></select>
                          </div>
                      </div>
                    <div class="form-group">
                      <label class="col-sm-12 control-label text-left">Select or drop your CSV file</label>
                      
                      <div class="col-sm-12">
                      <p>Click to select file or drag and drop a file below to upload your CSV. Column headers in the CSV must match the field names defined in the selected form.</p>
                        <iservice-files-upload ng-init="uploads = []" files="uploads" class="ng-isolate-scope"><div class="form-group">
                        <div>
                            <label class="drop-box">
                               Drop files here or click to upload
                            <input type="file" class="hide" multiple="">
                            </label>
                            <div>(Maximum 10 MB upload at one time.)</div>
                            <div class="imageuploadify">
                            <!-- ngRepeat: file in files -->
                            </div>
                        </div>
                        </div></iservice-files-upload>
                  
                      </div>
                    </div>
                    
                    <div class="form-group">
                        <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Set Your Run Parameter</h3></div>
                        <div class="col-md-12">
                          <label class="switch">
                              <Toggle v-model="processfirstrecord" />
                              <span class="mleft-15">Process First Record Only</span>
                          </label>
                          <p>Use this to test large files before processing. On the first record of the uploaded CSV will be processed. <br>After a successful run, disable the switch and reprocess the entire file.</p>
                        </div>
                    </div>
                     <div class="form-group">
                        <label class="col-md-12 control-label text-left">Set Your Run Parameters</label>
                        <div class="col-md-12">
                          <label class="switch">
                              <Toggle v-model="stoponfirsterror" />
                              <span class="mleft-15"> Stop On First Error</span>
                          </label>
                          <p>Use this to test large files before processing. On the first record of the uploaded CSV will be processed. <br>After a successful run, disable the switch and reprocess the entire file.</p>
                        </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-4 control-label text-left">&nbsp;</label>
                      <div class="col-md-6">
                        <button type="button" class="btn btn-primary margin-r-5">Submit Request</button>
                        <button type="button" class="btn btn-link margin-r-5">Cancel</button>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <button class="btn btn-sm btn-success mright-15">1 Success</button>
                       <button class="btn btn-sm btn-danger">0 Failure </button>
                    </div>


                    <div class="form-group">
                      <label class="col-sm-4 control-label text-left">&nbsp;</label>
                      <div class="col-md-6">
                        <button type="button" class="btn btn-primary margin-r-5">Resubmit Failed</button>
                        <button type="button" class="btn btn-primary margin-r-5">Download Failed Rows</button>
                      </div>
                    </div>

                  </div>
                </div>
            </div>
        </div>
     </section>
   </template>
   <style src="@vueform/toggle/themes/default.css"></style>
   <script>
   // @ is an alias to /src
   import Breadcrumb from '../components/Breadcrumb.vue';
    import iServiceSwitch from '../components/iServiceSwitch.vue';
    import Toggle from '@vueform/toggle'
   export default {
     name: 'Credit Memo Approval Form',
     components: {
       Breadcrumb,
       Toggle
     },
  data: function(){
      return{
        segment1 : false,
        segment2 : false,
        segment3 : false,
        segment4 : false
      }
         
  },
   methods: {
    toggleSegmentCollapsedState(i) {
      this['segment'+i] = !this['segment'+i] 
    }
  },
     ready () {
       $(document).ready(function ($) {
       })
     }
   }
   </script>